module.exports = __webpack_public_path__ + "static/media/ActiveFilters1.c571f4d7.svg";